/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiCredentials } from '../model/apiCredentials';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApiCredentialsService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCredentialsAddApiCredentials(model: ApiCredentials, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiCredentialsAddApiCredentials(model: ApiCredentials, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiCredentialsAddApiCredentials(model: ApiCredentials, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiCredentialsAddApiCredentials(model: ApiCredentials, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling apiCredentialsAddApiCredentials.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/apicredentials/create`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCredentialsDeleteApiCredentials(id: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiCredentialsDeleteApiCredentials(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiCredentialsDeleteApiCredentials(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiCredentialsDeleteApiCredentials(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiCredentialsDeleteApiCredentials.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<number>(`${this.basePath}/api/apicredentials/delete/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param username 
     * @param expiration 
     * @param dateCreated 
     * @param creatorId 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCredentialsGetAllApiCredentials(username?: string, expiration?: Date, dateCreated?: Date, creatorId?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ApiCredentials>>;
    public apiCredentialsGetAllApiCredentials(username?: string, expiration?: Date, dateCreated?: Date, creatorId?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApiCredentials>>>;
    public apiCredentialsGetAllApiCredentials(username?: string, expiration?: Date, dateCreated?: Date, creatorId?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApiCredentials>>>;
    public apiCredentialsGetAllApiCredentials(username?: string, expiration?: Date, dateCreated?: Date, creatorId?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }
        if (expiration !== undefined && expiration !== null) {
            queryParameters = queryParameters.set('expiration', <any>expiration.toISOString());
        }
        if (dateCreated !== undefined && dateCreated !== null) {
            queryParameters = queryParameters.set('dateCreated', <any>dateCreated.toISOString());
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ApiCredentials>>(`${this.basePath}/api/apicredentials/getall`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param apikey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCredentialsGetApiCredentialsByApikey(apikey?: string, observe?: 'body', reportProgress?: boolean): Observable<ApiCredentials>;
    public apiCredentialsGetApiCredentialsByApikey(apikey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiCredentials>>;
    public apiCredentialsGetApiCredentialsByApikey(apikey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiCredentials>>;
    public apiCredentialsGetApiCredentialsByApikey(apikey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (apikey !== undefined && apikey !== null) {
            queryParameters = queryParameters.set('apikey', <any>apikey);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ApiCredentials>(`${this.basePath}/api/apicredentials/getbyapikey`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCredentialsGetApiCredentialsById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ApiCredentials>;
    public apiCredentialsGetApiCredentialsById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiCredentials>>;
    public apiCredentialsGetApiCredentialsById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiCredentials>>;
    public apiCredentialsGetApiCredentialsById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ApiCredentials>(`${this.basePath}/api/apicredentials/getbyid`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param apiCredentials 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCredentialsUpdateApiCredentials(apiCredentials: ApiCredentials, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiCredentialsUpdateApiCredentials(apiCredentials: ApiCredentials, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiCredentialsUpdateApiCredentials(apiCredentials: ApiCredentials, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiCredentialsUpdateApiCredentials(apiCredentials: ApiCredentials, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (apiCredentials === null || apiCredentials === undefined) {
            throw new Error('Required parameter apiCredentials was null or undefined when calling apiCredentialsUpdateApiCredentials.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/apicredentials/UpdateApiCredentials`,
            apiCredentials,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
